export enum NotificationType {
  WELCOME = "WELCOME",
  ACCOUNT_INVITATION = "ACCOUNT_INVITATION",
  PROJECT_INVITATION = "PROJECT_INVITATION",
  PROJECT_ADDITION = "PROJECT_ADDITION",
  TEAM_INVITATION = "TEAM_INVITATION",
  TEAM_ADDITION = "TEAM_ADDITION",
  PASSWORD_RESET = "PASSWORD_RESET",
  USER_PASSWORD_CHANGED = "USER_PASSWORD_CHANGED",
  STORY_ASSIGNMENT = "STORY_ASSIGNMENT",
  TODO_ASSIGNMENT = "TODO_ASSIGNMENT",
  TODO_REMINDER = "TODO_REMINDER",
  TODO_CHANGED = "TODO_CHANGED",
  TODO_COMMENT_ACTIVITY = "TODO_COMMENT_ACTIVITY",
  TODO_REVIEW_REQUEST = "TODO_REVIEW_REQUEST",
  TODO_UPDATED = "TODO_UPDATED",
  TODO_COMPLETED = "TODO_COMPLETED",
  TODO_COMMENT_ADDED = "TODO_COMMENT_ADDED",
  TODO_COMMENT_REPLY = "TODO_COMMENT_REPLY",
  TODO_COMMENT_MENTION = "TODO_COMMENT_MENTION",
  TODO_PM_REVIEW_REQUEST = "TODO_PM_REVIEW_REQUEST",
  TODO_CLIENT_REVIEW_REQUEST = "TODO_CLIENT_REVIEW_REQUEST",
  UPDATE_STORY_TIME_LEFT_REMINDER = "UPDATE_STORY_TIME_LEFT_REMINDER",
  COMMENTS = "COMMENTS",
  ITEM_DEMO_VIDEO = "ITEM_DEMO_VIDEO",
  UNPRIORITIZED_BACKLOG_ADD_ITEM = "UNPRIORITIZED_BACKLOG_ADD_ITEM",
  BLOCKED_STORY_NOTIFICATION = "BLOCKED_STORY_NOTIFICATION",
  OBSOLETE_STORY_NOTIFICATION = "OBSOLETE_STORY_NOTIFICATION",
  STORY_DESCRIPTION_UPDATE = "STORY_DESCRIPTION_UPDATE",
  ITEM_SUB_TASK_ADDED_UPDATE = "ITEM_SUB_TASK_ADDED_UPDATE",
  ITEM_SUB_TASK_TIME_LEFT_UPDATED_TO_ZERO = "ITEM_SUB_TASK_TIME_LEFT_UPDATED_TO_ZERO",
  SPRINT_REVIEW_COMPLETED = "SPRINT_REVIEW_COMPLETED",
  SUPPORT_CASE_CREATED = "SUPPORT_CASE_CREATED",
  BUG_WATERMARK_EXCEEDED = "BUG_WATERMARK_EXCEEDED",
  SPRINT_RISK_ALERT = "SPRINT_RISK_ALERT",
  HALT_SPRINT_NOTIFICATION = "HALT_SPRINT_NOTIFICATION",
  TRIAL_EXPIRY_REMINDER = "TRIAL_EXPIRY_REMINDER",
  ITEM_CREATED = "ITEM_CREATED",
  ITEM_UPDATED = "ITEM_UPDATED",
  ITEM_UPDATE_STATUS = "ITEM_UPDATE_STATUS",
  ITEM_UPDATE_STORYPOINTS = "ITEM_UPDATE_STORYPOINTS",
  ITEM_UPDATE_DESCRIPTION = "ITEM_UPDATE_DESCRIPTION",
  ITEM_UPDATE_OWNER = "ITEM_UPDATE_OWNER",
  ITEM_UPDATE_ACTIVE_SPRINT_ADDED = "ITEM_UPDATE_ACTIVE_SPRINT_ADDED",
  UPDATE_TASK = "UPDATE_TASK",
  USER_MENTION = "USER_MENTION",
  SPRINT_RETROSPECTIVE = "SPRINT_RETROSPECTIVE",
  STORY_POKER_CREATED = "STORY_POKER_CREATED",
  MILESTONE_COMPLETED = "MILESTONE_COMPLETED",
  MILESTONE_AT_RISK = "MILESTONE_AT_RISK",
  MILESTONE_BACK_TO_TRACK = "MILESTONE_BACK_TO_TRACK",
  GOAL_REACHED = "GOAL_REACHED",
  JIRA_BACKLOG_IMPORT_COMPLETED = "JIRA_BACKLOG_IMPORT_COMPLETED",
  JIRA_BACKLOG_IMPORT_DISABLED = "JIRA_BACKLOG_IMPORT_DISABLED",
  JIRA_SYNCHRONIZATION_DISABLED = "JIRA_SYNCHRONIZATION_DISABLED",
  TIMESHEET_DECLINED = "TIMESHEET_DECLINED",
  TIMESHEET_APPROVED = "TIMESHEET_APPROVED",
  SPRINT_SYNC_ERROR = "SPRINT_SYNC_ERROR",
  ITEM_DELETED = "ITEM_DELETED",
  REACTION_ADDED_TO_COMMENT = "REACTION_ADDED_TO_COMMENT",
  REPLY_COMMENT = "REPLY_COMMENT",
  NEW_CURRENT_GOAL = "NEW_CURRENT_GOAL",
  ITEM_CONVERTED_TO_EPIC = "ITEM_CONVERTED_TO_EPIC",
  EPIC_COMMENTS = "EPIC_COMMENTS",
  IDEA_COMMENTS = "IDEA_COMMENTS",
  EPIC_UPDATED = "EPIC_UPDATED",
  IDEA_ACTIVITY = "IDEA_ACTIVITY",
  IDEA_ACTIVITY_CREATED = "IDEA_ACTIVITY_CREATED",
  IDEA_ACTIVITY_PROMOTED_TO_FEATURE = "IDEA_ACTIVITY_PROMOTED_TO_FEATURE",
  IDEA_ACTIVITY_CONVERTED_TO_EPIC = "IDEA_ACTIVITY_CONVERTED_TO_EPIC",
  IDEA_ACTIVITY_CONVERTED_TO_ITEM = "IDEA_ACTIVITY_CONVERTED_TO_ITEM",
  IDEA_ACTIVITY_UPDATE_DESCRIPTION = "IDEA_ACTIVITY_UPDATE_DESCRIPTION",
  CALENDAR_EVENT_CREATED = "CALENDAR_EVENT_CREATED",
  CALENDAR_EVENT_UPDATED = "CALENDAR_EVENT_UPDATED",
  CALENDAR_EVENT_DELETED = "CALENDAR_EVENT_DELETED",
  PLATFORM_LOAD_METRICS_EXCEEDED = "PLATFORM_LOAD_METRICS_EXCEEDED",
  UPCOMING_TIME_OFF_NOTIFICATION = "UPCOMING_TIME_OFF_NOTIFICATION"
}

export enum NotificationClass {
  NOTIFICATION = "NOTIFICATION",
  NOTIFICATION_TODO = "NOTIFICATION_TODO",
  NOTIFICATION_ITEM = "NOTIFICATION_ITEM",
  NOTIFICATION_TASK = "NOTIFICATION_TASK",
  NOTIFICATION_COMMENTS = "NOTIFICATION_COMMENTS",
  NOTIFICATION_BUG_WATERMARK = "NOTIFICATION_BUG_WATERMARK",
  NOTIFICATION_STORY_POKER = "NOTIFICATION_STORY_POKER",
  NOTIFICATION_SPRINT_RETROSPECTIVE = "NOTIFICATION_SPRINT_RETROSPECTIVE",
  NOTIFICATION_MILESTONE = "NOTIFICATION_MILESTONE",
  NOTIFICATION_GOAL = "NOTIFICATION_GOAL",
  NOTIFICATION_PROJECT_ADDITION = "NOTIFICATION_PROJECT_ADDITION",
  NOTIFICATION_TEAM_ADDITION = "NOTIFICATION_TEAM_ADDITION",
  NOTIFICATION_ACTIVE_SPRINT_ADDED = "NOTIFICATION_ACTIVE_SPRINT_ADDED",
  NOTIFICATION_TIMESHEET = "NOTIFICATION_TIMESHEET",
  ITEM_DELETED = "ITEM_DELETED",
  ITEM_CONVERTED_TO_EPIC = "ITEM_CONVERTED_TO_EPIC",
  REACTION_ADDED_TO_COMMENT = "REACTION_ADDED_TO_COMMENT",
  REPLY_COMMENT = "REPLY_COMMENT",
  NOTIFICATION_EPIC_COMMENTS = "NOTIFICATION_EPIC_COMMENTS",
  NOTIFICATION_IDEA_COMMENTS = "NOTIFICATION_IDEA_COMMENTS",
  NOTIFICATION_PLATFORM_LOAD_METRICS = "NOTIFICATION_PLATFORM_LOAD_METRICS",
  NEW_CURRENT_GOAL = "NEW_CURRENT_GOAL",
  NOTIFICATION_EPIC = "NOTIFICATION_EPIC",
  NOTIFICATION_IDEA_ACTIVITY = "NOTIFICATION_IDEA_ACTIVITY",
  NOTIFICATION_CALENDAR = "NOTIFICATION_CALENDAR",
  NOTIFICATION_TIME_OFF_IMPACT = "NOTIFICATION_TIME_OFF_IMPACT"
}

export const classByType: Record<NotificationType, NotificationClass> = {
  [NotificationType.WELCOME]: NotificationClass.NOTIFICATION,
  [NotificationType.ACCOUNT_INVITATION]: NotificationClass.NOTIFICATION,
  [NotificationType.PROJECT_INVITATION]: NotificationClass.NOTIFICATION,
  [NotificationType.PROJECT_ADDITION]: NotificationClass.NOTIFICATION_PROJECT_ADDITION,
  [NotificationType.TEAM_INVITATION]: NotificationClass.NOTIFICATION,
  [NotificationType.TEAM_ADDITION]: NotificationClass.NOTIFICATION_TEAM_ADDITION,
  [NotificationType.PASSWORD_RESET]: NotificationClass.NOTIFICATION,
  [NotificationType.USER_PASSWORD_CHANGED]: NotificationClass.NOTIFICATION,
  [NotificationType.STORY_ASSIGNMENT]: NotificationClass.NOTIFICATION,
  [NotificationType.TODO_ASSIGNMENT]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_REMINDER]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_CHANGED]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_COMMENT_ACTIVITY]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_REVIEW_REQUEST]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_UPDATED]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_COMPLETED]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_COMMENT_ADDED]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_COMMENT_REPLY]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_COMMENT_MENTION]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_PM_REVIEW_REQUEST]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.TODO_CLIENT_REVIEW_REQUEST]: NotificationClass.NOTIFICATION_TODO,
  [NotificationType.SPRINT_SYNC_ERROR]: NotificationClass.NOTIFICATION,
  [NotificationType.UPDATE_STORY_TIME_LEFT_REMINDER]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.REACTION_ADDED_TO_COMMENT]: NotificationClass.REACTION_ADDED_TO_COMMENT,
  [NotificationType.COMMENTS]: NotificationClass.NOTIFICATION_COMMENTS,
  [NotificationType.ITEM_DEMO_VIDEO]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.REPLY_COMMENT]: NotificationClass.REPLY_COMMENT,
  [NotificationType.UNPRIORITIZED_BACKLOG_ADD_ITEM]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.BLOCKED_STORY_NOTIFICATION]: NotificationClass.NOTIFICATION,
  [NotificationType.OBSOLETE_STORY_NOTIFICATION]: NotificationClass.NOTIFICATION,
  [NotificationType.STORY_DESCRIPTION_UPDATE]: NotificationClass.NOTIFICATION,
  [NotificationType.ITEM_SUB_TASK_ADDED_UPDATE]: NotificationClass.NOTIFICATION,
  [NotificationType.ITEM_SUB_TASK_TIME_LEFT_UPDATED_TO_ZERO]: NotificationClass.NOTIFICATION,
  [NotificationType.SPRINT_REVIEW_COMPLETED]: NotificationClass.NOTIFICATION,
  [NotificationType.SUPPORT_CASE_CREATED]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.BUG_WATERMARK_EXCEEDED]: NotificationClass.NOTIFICATION_BUG_WATERMARK,
  [NotificationType.SPRINT_RISK_ALERT]: NotificationClass.NOTIFICATION,
  [NotificationType.HALT_SPRINT_NOTIFICATION]: NotificationClass.NOTIFICATION,
  [NotificationType.TRIAL_EXPIRY_REMINDER]: NotificationClass.NOTIFICATION,
  [NotificationType.ITEM_CREATED]: NotificationClass.NOTIFICATION,
  [NotificationType.ITEM_UPDATED]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.ITEM_UPDATE_STATUS]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.ITEM_UPDATE_STORYPOINTS]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.ITEM_UPDATE_DESCRIPTION]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.ITEM_UPDATE_OWNER]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.ITEM_UPDATE_ACTIVE_SPRINT_ADDED]: NotificationClass.NOTIFICATION_ITEM,
  [NotificationType.UPDATE_TASK]: NotificationClass.NOTIFICATION_TASK,
  [NotificationType.USER_MENTION]: NotificationClass.NOTIFICATION_COMMENTS,
  [NotificationType.SPRINT_RETROSPECTIVE]: NotificationClass.NOTIFICATION_SPRINT_RETROSPECTIVE,
  [NotificationType.STORY_POKER_CREATED]: NotificationClass.NOTIFICATION_STORY_POKER,
  [NotificationType.MILESTONE_AT_RISK]: NotificationClass.NOTIFICATION_MILESTONE,
  [NotificationType.MILESTONE_COMPLETED]: NotificationClass.NOTIFICATION_MILESTONE,
  [NotificationType.MILESTONE_BACK_TO_TRACK]: NotificationClass.NOTIFICATION_MILESTONE,
  [NotificationType.GOAL_REACHED]: NotificationClass.NOTIFICATION_GOAL,
  [NotificationType.JIRA_BACKLOG_IMPORT_COMPLETED]: NotificationClass.NOTIFICATION,
  [NotificationType.JIRA_BACKLOG_IMPORT_DISABLED]: NotificationClass.NOTIFICATION,
  [NotificationType.JIRA_SYNCHRONIZATION_DISABLED]: NotificationClass.NOTIFICATION,
  [NotificationType.TIMESHEET_DECLINED]: NotificationClass.NOTIFICATION_TIMESHEET,
  [NotificationType.TIMESHEET_APPROVED]: NotificationClass.NOTIFICATION_TIMESHEET,
  [NotificationType.ITEM_DELETED]: NotificationClass.ITEM_DELETED,
  [NotificationType.ITEM_CONVERTED_TO_EPIC]: NotificationClass.ITEM_CONVERTED_TO_EPIC,
  [NotificationType.EPIC_COMMENTS]: NotificationClass.NOTIFICATION_EPIC_COMMENTS,
  [NotificationType.IDEA_COMMENTS]: NotificationClass.NOTIFICATION_IDEA_COMMENTS,
  [NotificationType.PLATFORM_LOAD_METRICS_EXCEEDED]:
    NotificationClass.NOTIFICATION_PLATFORM_LOAD_METRICS,
  [NotificationType.NEW_CURRENT_GOAL]: NotificationClass.NEW_CURRENT_GOAL,
  [NotificationType.EPIC_UPDATED]: NotificationClass.NOTIFICATION_EPIC,
  [NotificationType.IDEA_ACTIVITY]: NotificationClass.NOTIFICATION_IDEA_ACTIVITY,
  [NotificationType.IDEA_ACTIVITY_CREATED]: NotificationClass.NOTIFICATION_IDEA_ACTIVITY,
  [NotificationType.IDEA_ACTIVITY_PROMOTED_TO_FEATURE]:
    NotificationClass.NOTIFICATION_IDEA_ACTIVITY,
  [NotificationType.IDEA_ACTIVITY_CONVERTED_TO_EPIC]: NotificationClass.NOTIFICATION_IDEA_ACTIVITY,
  [NotificationType.IDEA_ACTIVITY_CONVERTED_TO_ITEM]: NotificationClass.NOTIFICATION_IDEA_ACTIVITY,
  [NotificationType.IDEA_ACTIVITY_UPDATE_DESCRIPTION]: NotificationClass.NOTIFICATION_IDEA_ACTIVITY,
  [NotificationType.CALENDAR_EVENT_CREATED]: NotificationClass.NOTIFICATION_CALENDAR,
  [NotificationType.CALENDAR_EVENT_UPDATED]: NotificationClass.NOTIFICATION_CALENDAR,
  [NotificationType.CALENDAR_EVENT_DELETED]: NotificationClass.NOTIFICATION_CALENDAR,
  [NotificationType.UPCOMING_TIME_OFF_NOTIFICATION]: NotificationClass.NOTIFICATION_TIME_OFF_IMPACT
}
